// This file is used for maintain and manage progressBar services.
(function () {
  'use strict';
  angular.module('obex').
  service('progressBar', ['ngProgressFactory',
    function (ngProgressFactory) {
      var progressBar = ngProgressFactory.createInstance();
      return {
        getProgressBar: function () {
          return progressBar;
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/progressBar.service.js